<template>
    <b-overlay :show="loading">
        <h1>{{ task.name }} Related Quality Control Samples</h1>
        <quality-control-related-list-table :task="task.id" />
    </b-overlay>
</template>
<script>
import QualityControlRelatedListTable from "./QualityControlRelatedListTable";

export default {
    name: "QualityControlRelatedList",
    components: {
        QualityControlRelatedListTable,
    },
    props: {
        task: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            loading: true,
        };
    },
    methods: {
        async init() {
            this.loading = false;
        }
    },
    created() {
        this.init();
    }
};
</script>